import { PdfGen, PdfSize, PdfRect, PdfBrush, PdfUnit } from '../../pdf/pdf';
import { ILayoutLabelTextGen } from '../layoutLabelText';
import { OptsLabelText } from '../optsLabelText';
import { GUtil } from '../../pdf/gutil';
import { IItemCount } from '@educraft/base';
import { calcGridRects } from '../../pdf/board/grid';
import '../../pdf/draw/primitives';
import '../../pdf/draw/image';
import '../../pdf/draw/barcode';
import '../../pdf/draw/cut';

/**
 * LabelText.QR — Grid layout cards; label in top half, QR of text in bottom.
 */
export class QR implements ILayoutLabelTextGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 3;
  }
  countMax(): number {
    return 24;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const page = pdf.addPage(true); // landscape
    const margin = PdfUnit.FromMillimeters(5);
    const border = PdfUnit.FromMillimeters(5);

    const count = Math.min(opts.list.length, this.countMax());
    const { rects, cellSize } = calcGridRects(count, margin, PdfSize.A4H);

    const allLabelTexts = opts.list.slice(0, count).map((item) => [item.label.getText() ?? '']);
    const halfH = cellSize.height / 2;
    const labelSize = new PdfSize(cellSize.width - 2 * border, halfH - border);
    const labelFont = page.adjustFontMulti(allLabelTexts, GUtil.baseFont, labelSize);

    for (let i = 0; i < rects.length; i++) {
      const rect = rects[i];
      const item = opts.list[i];

      // Draw cell border
      page.drawRectangle(GUtil.cutPen, null, rect);

      // Split cell vertically: top for label, bottom for QR
      const labelRect = new PdfRect(
        rect.left + border,
        rect.top + border,
        rect.width - 2 * border,
        halfH - border
      );
      page.drawLabel(item.label as any, { rect: labelRect, font: labelFont });

      // Bottom for QR code with padding
      const qrPadding = PdfUnit.FromMillimeters(5);
      const qrSide = Math.min(rect.width, halfH) - 2 * qrPadding;
      const qrRect = new PdfRect(
        rect.left + (rect.width - qrSide) / 2,
        rect.top + halfH + (halfH - qrSide) / 2,
        qrSide,
        qrSide
      );

      page.drawQr(qrRect, PdfBrush.Black, item.text);
    }
  }
}
